module.exports = __webpack_public_path__ + "img/invite_btn.3e769a33.png";